import React, { useState } from 'react'
import { SortToggle } from 'components/SortToggle'
import './styles.scss'

interface Props {
  images: [string, string]
  labels: [[string, string], [string, string]]
}

export const ImageSwitch = ({ images, labels }: Props) => {
  const [switched, setSwitched] = useState(false)
  return (
    <div className='ImageSwitch'>
  
      <div className='title'>{switched ? labels[1][0] : labels[0][0]}</div>
      <div className='sub'>{switched ? labels[1][1] : labels[0][1]}</div>
      <SortToggle
        sort={switched}
        setSort={setSwitched}
        labels={['', 'Knaben', 'Mädchen']}
      />
      <img src={switched ? images[1] : images[0]} />
    </div>
  )
}
